exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headStyle {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 500;\n  margin-top: 10px;\n  color: #6b6a6a; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/poireport/poireport.component.scss
// module id = ../../../../../src/app/poireport/poireport.component.scss
// module chunks = main